<div class="schedule-portal container-fluid bg-light-gray p-0">
  <div class="row row-cols-1 gy-2 m-0">
    <div class="col mt-0 bg-primary-white navbar-spacer">
      <app-navbar class="fixed-top" />
    </div>
    <div class="col col-lg-6 bg-primary-white position-relative">
      @if (isLoading()) {
        <div class="schedule-loading-overlay">
          <div class="spinner-border text-secondary-purple"></div>
        </div>
      }
      <schedule-calendar
        class="p-0"
        [events]="events()"
        (dayClick)="dayClick($event)"
        (todayInit)="todayInit($event)"
        (datesSet)="datesSet($event)"
      />
    </div>
    <div class="col col-lg-6 p-0 px-2 bg-primary-white">
      <div class="upcoming-class-block bg-primary-white p-3">
        <div class="fs-4 fw-bold text-secondary-purple">
          {{ dayInfo().date | myDate }}
        </div>
        <div class="text-secondary fs-5">
          {{ dayInfo().date | myDate: true }}
        </div>
        <ul class="upcoming-class-list list-group mt-3">
          @for (clazz of dayClasses(); track $index) {
            <li
              class="list-group-item bg-secondary-purple-10 py-3 mb-3"
              (click)="showClassDetail(clazz)"
            >
              <div class="row align-items-center">
                <div class="col-10">
                  <div class="fs-6 mb-2 text-secondary-purple fw-bold">
                    <span class="fas fa-circle me-1 text-accent-orange"></span>
                    @switch (clazz.type) {
                      @case ('Independent Ride') {
                        {{ 'app.class.independentRide' | translate }}
                      }
                      @case ('Term Ride') {
                        {{ 'app.class.termRide' | translate }}
                      }
                      @case ('Group Ride') {
                        {{ 'app.class.groupRide' | translate }}
                      }
                      @default {
                        {{ clazz.type }}
                      }
                    }
                  </div>
                  <div class="fs-5 fw-bold mb-2">{{ clazz.venue }}</div>
                  <div class="text-secondary">
                    <span class="far fa-clock me-1"></span>
                    {{ clazz?.shortTimeStart() }} - {{ clazz?.shortTimeEnd() }} · {{ clazz?.getDuration() }}{{ 'app.leaveRequest.mins' | translate }}
                  </div>
                </div>
                <div class="col-2">
                  <span
                    class="class-detail-button fas fa-arrow-circle-right text-secondary-purple"
                  ></span>
                </div>
              </div>
            </li>
          } @empty {
            <div class="ratio ratio-1x1">
              <div class="d-grid align-items-center justify-content-center">
                <span>{{ 'app.schedule.noClass' | translate }}</span>
              </div>
            </div>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
@defer {
  <app-class-detail></app-class-detail>
}
